// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =================================================================================================================
// Nav Bar
// =================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling down
// -----------------------------------------------------------------------------------------------------------------
if (nav) {
    window.addEventListener('scroll', function () {
        const scrollPoint = 20; // pixel value after which state change is triggered
        this.scrollY > scrollPoint ? nav.classList.add('scrolled') : nav.classList.remove('scrolled');
    })
}



// Set the nav size for use in CSS
// ---------------------------------------------------------------------------------------------------------------------
function setCssNavbarHeight() {
    if (this.scrollY < 30 ) {
        document.documentElement.style.setProperty('--nav-height', nav.offsetHeight + "px");
    }
}
window.addEventListener('load', setCssNavbarHeight);
document.addEventListener('DOMContentLoaded', setCssNavbarHeight, false);
window.addEventListener('resize', setCssNavbarHeight, false);



// Check for WordPress admin bar and pushes Nav down if it exists
// ---------------------------------------------------------------------------------------------------------------------
if (adminBar) {
    nav.style.top = adminBar.offsetHeight + 'px';

    window.addEventListener('resize', function () {
        nav.style.top = adminBar.offsetHeight + 'px';
    });

    // Change Nav state after scrolling past start scrollPoint
    window.addEventListener('scroll', function () {
        if (breakpointManager.matchesBreakpointsDown('xs')) {
            let adminBarHeight = adminBar.offsetHeight;

            if (this.scrollY > adminBarHeight) {
                nav.style.top = '0px';
            } else if (this.scrollY < adminBarHeight) {
                nav.style.top = adminBar.offsetHeight - this.scrollY + 'px';
            }
        }
    });

}



// =====================================================================================================================
// Splide
// =====================================================================================================================
import Splide from '@splidejs/splide';


// Slider Group Block
// ------------------------------------------------------------------------------------------------------------------
const sliderGroups = document.querySelectorAll('.slider-group .splide');
if (sliderGroups.length) {
    sliderGroups.forEach(function(sliderGroup) {
        const sliderOptions = {
            type: sliderGroup.dataset.slidertype ?? 'slide',
            arrows: sliderGroup.dataset.arrows === 'true',
            pagination: sliderGroup.dataset.pagination === 'true',
            drag: sliderGroup.dataset.drag === 'true',
            autoplay: sliderGroup.dataset.autoplay === 'true',
            perPage: sliderGroup.dataset.perpage ?? 1,
            interval: sliderGroup.dataset.interval ?? 5000,
            gap: sliderGroup.dataset.gap,
            padding: sliderGroup.dataset.padding,
            breakpoints: {
                768: {
                    arrows: false,
                },
            }
        }
        const slider = new Splide(sliderGroup, sliderOptions)
        slider.mount();
    });
}



// Logos Slider
// ------------------------------------------------------------------------------------------------------------------
const logosSlider = document.querySelectorAll('.logos-slider .splide');
if (logosSlider.length) {
    logosSlider.forEach(function(logoSlider) {
        const slider = new Splide(logoSlider, {
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 2000,
            type: 'loop',
            perMove: 1,
            gap: '5rem',
            focus: 'center',
            fixedWidth: '200px',
            fixedHeight: '90px',
            breakpoints: {
                1460: {
                    gap: '4.5rem',
                },
                1200: {
                    gap: '3.5rem',
                },
                992: {
                    gap: '3rem',
                    fixedWidth: '175px',
                    fixedHeight: '85px',
                },
                768: {
                    gap: '2.75rem',
                    fixedWidth: '150px',
                    fixedHeight: '80px',
                },
                576: {
                    gap: '2.5rem',
                    fixedWidth: '125px',
                    fixedHeight: '70px',
                },
                390: {
                    gap: '2.5rem',

                }
            }
        })
        slider.mount();
    });
}



// Image Slider
// ------------------------------------------------------------------------------------------------------------------
const imageSlider = document.querySelectorAll('.image-slider .splide');
if (imageSlider.length) {
    imageSlider.forEach(function(imageSlider) {
        const slider = new Splide(imageSlider, {
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 3000,
            type: 'loop',
            perMove: 1,
            gap: '1.5rem',
            focus: 'center',
            fixedWidth: '415px',
            breakpoints: {
                1200: {
                    fixedWidth: '400px',
                },
                992: {
                    fixedWidth: '375px',
                },
                768: {
                    fixedWidth: '350px',
                },
                576: {
                    fixedWidth: '325px',
                    gap: '1rem',
                },
                390: {
                    fixedWidth: '275px',
                }
            }
        })
        slider.mount();
    });
}





// =================================================================================================================
// Partner and Post Filters
// =================================================================================================================
const postResetBtn = document.getElementById("post-reset-btn");
const postFormFilter = document.getElementById("post-filters");
const resourceResetBtn = document.getElementById("resource-reset-btn");
const resourceFormFilter = document.getElementById("resource-filters");

// Reset Button Functionality
if (postResetBtn){
    postResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/blog')
    });
}
if (resourceResetBtn){
    resourceResetBtn.addEventListener("click", () => {
        window.location.assign(window.location.origin + '/resources')
    });
}

// Submit form on select change
if (postFormFilter){
    let selects = document.querySelectorAll('#post-filters .form-select');
    selects.forEach( select => {
        select.addEventListener('change', function (){
            // Handle if filtering from beyond page 1
            if (window.location.href.indexOf("/page/") > -1) {
                postFormFilter.action = window.location.origin + '/blog';
                postFormFilter.submit();
            } else {
                postFormFilter.submit();
            }
        })
    })
}
if (resourceFormFilter){
    let selects = document.querySelectorAll('#resource-filters .form-select');
    selects.forEach( select => {
        select.addEventListener('change', function (){
            // Handle if filtering from beyond page 1
            if (window.location.href.indexOf("/page/") > -1) {
                resourceFormFilter.action = window.location.origin + '/resources';
                resourceFormFilter.submit();
            } else {
                resourceFormFilter.submit();
            }
        })
    })
}


// JS Filter on Location page
const countyFilter = document.querySelector("#location-filters #county");
const locationCards = document.querySelectorAll(".location-card");
if (countyFilter && locationCards){
    countyFilter.addEventListener('change', function (){
        let selectedCounty = this.value;

        locationCards.forEach(function(card){
            if (selectedCounty === "all") {
                card.parentElement.classList.remove('d-none')
            } else {
                let dataCounties = card.dataset.counties;
                if (dataCounties) {
                    let cardCats = dataCounties.split(" ");
                    if (cardCats.includes(selectedCounty)) {
                        card.parentElement.classList.remove('d-none')
                    } else {
                        card.parentElement.classList.add('d-none')
                    }
                }
            }
        });
    })
}





// =================================================================================================================
// Expand Block
// =================================================================================================================
const expandBlocks = document.querySelectorAll('.epic-expand-block');
expandBlocks.forEach(function(expandBlock) {
    const expandBtn = expandBlock.querySelector('.epic-expand-button');

    if (expandBtn) {
        expandBtn.addEventListener('click', function(e) {
            e.preventDefault();

            if (expandBlock.classList.contains('collapsed')) {
                expandBlock.classList.remove('collapsed');
                expandBlock.classList.add('expanded');
                expandBlock.setAttribute('aria-expanded', 'true');
                expandBtn.innerHTML = expandBtn.dataset.collapseText;
            } else if (expandBlock.classList.contains('expanded')) {
                expandBlock.classList.remove('expanded');
                expandBlock.classList.add('collapsed');
                expandBlock.setAttribute('aria-expanded', 'false');
                expandBtn.innerHTML = expandBtn.dataset.expandText;
            }
        });
    }
})

